import React from 'react';
export function WhatIsHSMSection() {
  return <section data-id="element-4362">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4363">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4364">
          What is High Speed Machining?
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 space-y-8" data-id="element-4365">
        <div className="text-gray-700 text-lg leading-relaxed space-y-4" data-id="element-4366">
          <p data-id="element-4367">
            High-speed machining, specifically milling, has the same variables
            as traditional milling. There are speeds and feeds to set and a
            depth of cut to be determined. However, in a high-speed machining
            operation, slow, heavy cuts are replaced by fast, lighter cuts.
          </p>
          <p data-id="element-4368">
            While it may seem counterproductive to take lighter cuts when heavy
            cuts are possible, shops that can make this switch in thinking will
            produce accurate parts faster.
          </p>
          <p data-id="element-4369">
            Defining high-speed machining is difficult because it can be one of
            many operations, or a combination of them. It can be defined as:
          </p>
          <ul className="list-disc list-inside pl-4 space-y-2 font-bold text-navy" data-id="element-4370">
            <li data-id="element-4371">Machining at a high cutting speed (vc).</li>
            <li data-id="element-4372">Machining with a high spindle speed (n).</li>
            <li data-id="element-4373">Machining with a high feed rate (vf).</li>
            <li data-id="element-4374">Machining with a high removal rate (Q).</li>
          </ul>
          <p className="font-bold text-navy mt-4" data-id="element-4375">
            High-speed machining is not defined, however, as machining with a
            high material removal rate using a large axial depth of cut (Ap) or
            large radial depth of cut (Ae).
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center pt-6 border-t border-gray-100" data-id="element-4376">
          <div className="text-gray-700 text-lg leading-relaxed" data-id="element-4377">
            <p data-id="element-4378">
              High speed machining is usually associated with any spindle speed
              above 15k rpm, but it is much more than just a faster spindle. The
              whole machine must be considered when selecting a good candidate
              machine for HSM. Thermal compensation, overall machine rigidity
              and construction, positional feedback, the motion control system,
              tool retention, and many other characteristics must be looked at,
              in detail, before determining that a particular machine is
              suitable for the task.
            </p>
          </div>
          <div data-id="element-4379">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/High%20Speed%20Machining%20Mill%20Construction.png800x800.png" alt="High Speed Machining Mill Construction" className="w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4380" />
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-start pt-6 border-t border-gray-100" data-id="element-4381">
          <div data-id="element-4382">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/EDM%20vs%20High%20Speed%20Machining%20(HSM).png" alt="EDM vs High Speed Machining" className="w-full h-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4383" />
          </div>
          <div className="text-gray-700 text-lg leading-relaxed space-y-4" data-id="element-4384">
            <p data-id="element-4385">
              Traditionally, finish machining of hardened materials was
              performed by the use of EDM technology; and although this process
              was very effective, shops were continuously looking for faster and
              more efficient ways to produce their products. Eventually, as
              CAD/CAM software technology evolved, and new and more productive
              toolpath generation became available, the use of these advanced
              CAM systems also began to grow. Although the use of this
              technology was primarily focused on the die mold industry in the
              beginning, it has become much more prevalent today - and is
              present in all areas of the manufacturing arena. Subsequently, and
              in addition to efficiently removing large amounts of material very
              quickly, the technology has proven to be quite effective for
              machining thin walled features as well.
            </p>
            <p data-id="element-4386">
              Although the machine tool itself must be robust and well equipped
              enough for high speed machining, the real magic lies in the
              toolpath generated by today's advanced CAM software packages. The
              ability to produce a cutter path with a consistent chip load and
              tool engagement - especially in the corners - is really the secret
              sauce to the whole process. The finite control of the toolpath,
              and the ability to consistently control the amount of material
              engagement the tool will encounter, allows for dramatic increases
              in the cutting parameters. Even small diameter tooling can be
              pushed far beyond traditional limits.
            </p>
            <div className="text-center pt-4" data-id="element-4387">
              <a href="https://camplete.com/" target="_blank" rel="noopener noreferrer" className="inline-block hover:opacity-80 transition-opacity" data-id="element-4388">
                <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/Camplete%20TruePath.png" alt="Camplete TruePath" className="h-16 object-contain mx-auto" data-id="element-4389" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}